import React from 'react';
import { addMinutes } from 'date-fns';

import PageBaseProps from 'types/PageBase';

import { useSelector } from 'hooks';
import { isCourtesyVehicleCheckAccepted, isVehicleCheckAccepted } from 'modules/form/selectors';
import { useGetVCLinkQuery } from 'modules/vehicleCheck/service';
import { getSelectedSelfServiceId } from 'modules/auth/selectors';

import Content from './Content';

const Instructions: React.FC<PageBaseProps> = ({ onNext }) => {
  const selfServiceId = useSelector(getSelectedSelfServiceId);
  const vehicleCheckAccepted = useSelector(isVehicleCheckAccepted);
  const courtesyVehicleCheckAccepted = useSelector(isCourtesyVehicleCheckAccepted);

  const { data, isLoading, isSuccess } = useGetVCLinkQuery({ selfServiceId });

  const expirationTime = React.useMemo(() => {
    const expire = !isLoading && data?.exp ? parseInt(data.exp, 10) : 60; // 1 hour
    return addMinutes(new Date(), expire).toISOString();
  }, [data, isLoading]);

  return (
    <div className="main-content text-center grid grid-flow-row auto-rows-auto">
      {isSuccess &&
        <Content
          onNext={onNext}
          vehicleCheckLink={data.url}
          vehicleCheckLinkExpiredAt={expirationTime}
          vehicleCheckAccepted={vehicleCheckAccepted}
          courtesyVehicleCheckAccepted={courtesyVehicleCheckAccepted}
        />
      }
    </div>
  );
};

export default Instructions;
